<script>import { twMerge } from "tailwind-merge";
export let spanClass = "block text-sm text-gray-500 sm:text-center dark:text-gray-400";
export let aClass = "hover:underline";
export let year = (/* @__PURE__ */ new Date()).getFullYear();
export let href = "";
export let by = "";
export let target = void 0;
export let copyrightMessage = "All Rights Reserved.";
let spanCls = twMerge(spanClass, $$props.classSpan);
let aCls = twMerge(aClass, $$props.classA);
</script>

<span class={spanCls}>
  &copy; {year}
  {#if href}
    <a {...$$restProps} {href} {target} class={aCls}>
      {by}
    </a>
  {:else}
    <span class="ms-1">{by}</span>
  {/if}
  {copyrightMessage}
</span>

<!--
@component
[Go to docs](https://flowbite-svelte.com/)
## Props
@prop export let spanClass: string = 'block text-sm text-gray-500 sm:text-center dark:text-gray-400';
@prop export let aClass: string = 'hover:underline';
@prop export let year: number = new Date().getFullYear();
@prop export let href: string = '';
@prop export let by: string = '';
@prop export let target: string | undefined = undefined;
@prop export let copyrightMessage: string = 'All Rights Reserved.';
-->
